import BaseAPI from './base'
/**
 * API xử lý xếp hạng
 */
class RankingAPI extends BaseAPI {}

export default new RankingAPI('v1/rankings', 'Ranking')
